<div *ngIf="dealer">
  <div mat-dialog-title>
    <h4 *ngIf="dealer.dealer_ID" class="pl-3" i18n>Edit Account</h4>
    <h4 *ngIf="!dealer.dealer_ID" class="pl-3" i18n>Add Account</h4>
  </div>
  <div class="form-inline mb-2">
    <span *ngIf="dealer.dealer_ID" i18n>To edit your account information, update the form below then click Submit</span>
    <span *ngIf="!dealer.dealer_ID" i18n>To add dealer information, update the form below then click Submit</span>
    <span class="float-right warning" i18n>
      * Required Information
    </span>
  </div>
  <form #form="ngForm" (ngSubmit)="saveAccount(form)">
    <div mat-dialog-content>
      <div class="row pl-3">
        <div class="form-group form-inline pr-2">
          <span class="warning">* </span>
          <label class="pr-2" for="businessName" i18n>Business Name</label>
          <div>
            <input id="businessName" name="businessName" class="form-control" [(ngModel)]="dealer.dealer_BusinessName"
                   max="200"
                   required #businessName="ngModel"
                   [class.field-error]="form.submitted && businessName.invalid">
            <div [hidden]="!form.submitted || businessName.valid"
                 class="alert alert-danger" i18n>
              Enter a business name
            </div>
          </div>
        </div>
      </div>

      <div class="row pl-3">
        <div class="form-group form-inline pr-2">
          <span class="warning">* </span>
          <label class="pr-2" for="firstName" i18n>Contact First Name</label>
          <div>
            <input id="firstName" name="firstName" class="form-control" [(ngModel)]="dealer.dealer_FirstName"
                   required #firstName="ngModel"
                   [class.field-error]="form.submitted && firstName.invalid">
            <div [hidden]="!form.submitted || firstName.valid"
                 class="alert alert-danger" i18n>
              Enter a first name
            </div>
          </div>
        </div>
        <div class="form-group form-inline pr-2">
          <span class="warning">* </span>
          <label class="pr-2" for="lastName" i18n>Contact Last Name</label>
          <div>
            <input id="lastName" name="lastName" class="form-control" [(ngModel)]="dealer.dealer_LastName"
                   required #lastName="ngModel"
                   [class.field-error]="form.submitted && lastName.invalid">
            <div [hidden]="!form.submitted || lastName.valid"
                 class="alert alert-danger" i18n>
              Enter a last name
            </div>
          </div>
        </div>
        <div class="form-group form-inline pr-2">
          <label class="pr-2" for="phoneNumber">Contact Phone</label>
          <div>
            <input id="phoneNumber" name="phoneNumber" type="tel"
                   placeholder="(999) 999-9999"
                   appPhoneMask
                   class="form-control"
                   [(ngModel)]="dealer.dealer_OfficePhone"
                   #phoneNumber="ngModel" />
            <div [hidden]="!form.submitted || phoneNumber.valid"
                 class="alert alert-danger" i18n>
              Enter a valid phone
            </div>
          </div>
        </div>
        <div class="form-group form-inline pr-2">
          <span class="warning">* </span>
          <label class="pr-2" for="email" i18n>Contact Email</label>
          <div>
            <input id="email" name="email" type="email" required
                   placeholder="email"
                   class="form-control"
                   [(ngModel)]="dealer.dealer_Email"
                   #email="ngModel" />
            <div [hidden]="!form.submitted || email.valid"
                 class="alert alert-danger" i18n>
              Enter an email
            </div>
          </div>
        </div>
      </div>
      <div class="row pl-3">
        <div class="form-group form-inline pr-2">
          <span class="warning">* </span>
          <label class="pr-2" for="address1" i18n>Address</label>
          <div>
            <input id="address1" name="address1" class="form-control" [(ngModel)]="dealer.dealer_Address1"
                   required #address1="ngModel"
                   [class.field-error]="form.submitted && address1.invalid">
            <div [hidden]="!form.submitted || address1.valid"
                 class="alert alert-danger" i18n>
              Address Line 1 is invalid
            </div>
          </div>
        </div>
        <div class="form-group form-inline pr-2">
          <label class="pr-2" for="address2" i18n>Address (2)</label>
          <div>
            <input id="address2" name="address2" class="form-control" [(ngModel)]="dealer.dealer_Address2"
                   #address2="ngModel"
                   [class.field-error]="form.submitted && address2.invalid">
            <div [hidden]="!form.submitted || address2.valid"
                 class="alert alert-danger" i18n>
              Address Line 2 is invalid
            </div>
          </div>
        </div>
      </div>
      <div class="row pl-3">
        <div class="form-group form-inline pr-2">
          <span class="warning">* </span>
          <label class="pr-2" for="city" i18n>City</label>
          <div>
            <input id="city" name="city"
                   required
                   placeholder="city"
                   class="form-control"
                   [(ngModel)]="dealer.dealer_City"
                   #city="ngModel"
                   [class.field-error]="form.submitted && city.invalid">
            <div [hidden]="!form.submitted || city.valid"
                 class="alert alert-danger" i18n>
              City is invalid
            </div>
          </div>
        </div>
        <div class="form-group form-inline pr-2">
          <span class="warning">* </span>
          <label class="pr-2" for="state" i18n>State</label>
          <div>
            <select [(ngModel)]="dealer.dealer_State" name="state" id="state" class="form-control select-bidit" required #state="ngModel"
                    [class.field-error]="form.submitted && state.invalid">
              <option value="" selected="">-</option>
              <option *ngFor="let state of states;  let i=index" [(ngValue)]="states[i]">{{state}}</option>
            </select>
            <div [hidden]="!form.submitted || state.valid"
                 class="alert alert-danger" i18n>
              State is invalid
            </div>
          </div>
        </div>
        <div class="form-group form-inline pr-2">
          <span class="warning">* </span>
          <label class="pr-2" for="postal" i18n>Zip</label>
          <div>
            <input id="postal" name="postal"
                   required minlength="5" maxlength="10"
                   placeholder="zip"
                   class="form-control"
                   [(ngModel)]="dealer.dealer_Postal"
                   #postal="ngModel" />
            <div [hidden]="!form.submitted || postal.valid"
                 class="alert alert-danger" i18n>
              Enter a valid zip
            </div>
          </div>
        </div>
      </div>
      <div class="row pl-3">
        <div *ngIf="isDealerAdmin" class="form-group form-inline pr-2">
          <label class="pr-2" for="dealer_QuoteExpires" i18n>Expire Quotes After</label>
          <select name="dealer_QuoteExpires" id="dealer_QuoteExpires" class="form-control select-bidit"
                  [(ngModel)]="dealer.dealer_QuoteExpires" #dealer_QuoteExpires="ngModel">
            <option [ngValue]="undefined">-</option>
            <option value="30" i18n>30 Days</option>
            <option value="60" selected="" i18n>60 Days</option>
            <option value="90" i18n>90 Days</option>
          </select>
        </div>
        <div *ngIf="isDealerAdmin" class="form-group form-inline pr-2">
          <label class="pr-2" for="laborBurden" i18n>Labor Burden %</label>
          <input name="dealer_LaborBurden" type="number" id="dealer_LaborBurden" class="form-control"
                 [(ngModel)]="dealer.dealer_LaborBurden" #dealer_LaborBurden="ngModel" />
        </div>
      </div>
      <div class="form-group form-inline pl-2">
        <label class="pr-2" i18n>Hours of operation</label>
        <textarea id="officeHours" name="officeHours" type="text"
                  placeholder="Office Hours"
                  class="form-control col-md-6"
                  [(ngModel)]="dealer.dealer_OfficeHours"
                  #officeHours="ngModel">
          </textarea>
      </div>
      <div class="form-group form-inline pl-2">
        <label class="pr-2" i18n>Licenses Purchased</label>
        <input id="licensesPurchased" name="licensesPurchased" type="number" min="0"
               placeholder="Licenses Purchased" i18n-placeholder
               disabled="{{isDealerAdmin}}"
               class="form-control"
               [(ngModel)]="dealer.dealer_LicensesPurchased"
               #licensesPurchased="ngModel" />
      </div>
      <div class="form-group form-inline pl-2" *ngIf="!isDealerAdmin">
        <label class="pr-2" i18n>Region</label>
        <select id="region_ID" name="region_ID" type="number" min="0"
                placeholder="Region"
                class="form-control"
                [(ngModel)]="dealer.region_ID"
                #region_ID="ngModel">
          <option [ngValue]="undefined">-</option>
          <option *ngFor="let region of regions" [(ngValue)]="region.region_ID">{{region.region_Desc}}</option>
        </select>
      </div>
      <div class="form-group form-inline pl-2">
        <label class="pr-2" for="idiBranch_emai" i18n>Email</label>
        <input id="idiBranch_emai" name="idiBranch_emai" type="email"
               max="100"
               placeholder="email"
               class="form-control w-50"
               [(ngModel)]="dealer.idiBranch_Email"
               disabled="{{isDealerAdmin}}"
               #email="ngModel" />
        <div *ngIf="!isDealerAdmin" [hidden]="!form.submitted || email.valid"
             class="alert alert-danger" i18n>Enter a valid email</div>
      </div>
      <div class="form-group form-inline pl-2">
        <label class="pr-2" i18n>Customer No</label>
        <input id="customerNumber" name="customerNumber" class="form-control"
               maxlength="20"
               placeholder="Customer Number"
               disabled="{{isDealerAdmin}}"
               [(ngModel)]="dealer.customerNumber"
               #customerNumber="ngModel" />
        <div *ngIf="!isDealerAdmin" [hidden]="!form.submitted || customerNumber.valid"
             class="alert alert-danger" i18n>
          Enter a valid customer number
        </div>
      </div>
      <div class="row pl-3">
        <div class="form-group form-inline pr-2">
          <label class="pr-2" for="businessName" i18n>Salesperson</label>
          <div>
            <input id="salesPerson" name="salesPerson" class="form-control"
                   [(ngModel)]="dealer.salesperson"
                   #salesPerson="ngModel"
                   disabled="{{isDealerAdmin}}"
                   [class.field-error]="form.submitted && salesPerson.invalid">
            <div *ngIf="!isDealerAdmin" [hidden]="!form.submitted || salesPerson.valid"
                 class="alert alert-danger" i18n>
              Enter a valid salesperson name
            </div>
          </div>
        </div>
      </div>
      <div class="form-group form-inline pl-2" *ngIf="!isDealerAdmin">
        <label class="pr-2" i18n>Standard Dealer</label>
        <input type="checkbox" class="bidit-switch mr-1" name="quoteOnly" id="quoteOnly" [(ngModel)]="dealer.dealer_QuoteOnly">
        <label class="pr-2" i18n>Quote Only</label>
      </div>
      <div class="form-group form-inline pl-2">
        <label class="w-auto mr-2" for="reportfillColor" i18n>Contract Fill Color: </label>
        <input type="color" id="reportFillColor" name="reportFillColor" class="form-control w-25" [(ngModel)]="dealer.contractFillColor">
      </div>
      <div class="form-group form-inline pl-2">
        <label class="w-auto mr-2" for="reportFillTextColor" i18n>Text Color: </label>
        <input type="color" id="reportFillTextColor" name="reportFillTextColor" class="form-control w-25" [(ngModel)]="dealer.contractFillTextColor">
      </div>
      <div class="form-group form-inline pl-2">
        <label class="w-auto mr-2" for="reportLogoPosition" i18n>Contract Logo Position: </label>
        <select name="reportLogoPosition" class="form-control select-bidit w-25" [(ngModel)]="dealer.contractLogoPosition">
          <option value="1">Center</option>
          <option value="2">Left</option>
          <option value="3">Right</option>
        </select>
      </div>
      <div class="form-group form-inline pl-2">
        <label class="w-auto mr-2" for="dealerRounding" i18n>Round: </label>
        <select name="dealerRounding" class="form-control select-bidit w-25" [(ngModel)]="dealer.dealer_Rounding">
          <option value="1">Up - nearest dollar</option>
          <option value="2">Nearest decimal</option>
        </select>
      </div>

    </div>
    <div *ngIf="errors" class="row alert alert-danger" role="alert">
      <strong>{{errors}}</strong>
    </div>
    <mat-dialog-actions align="right">
      <button type="submit" value="submit" name="submit" id="submit" class="btn btn-bidit-submit btn-md mr-3" [disabled]="isRequesting" i18n>Submit</button>
      <a (click)="onNoClick()" class="btn btn-bidit-cancel btn-md" i18n>Cancel</a>
    </mat-dialog-actions>
    <app-spinner [isRunning]="isRequesting"></app-spinner>

    <div class="mt-3">
      <div [hidden]="!form.submitted || form.valid"
           class="alert alert-danger" i18n>
        Validation issues encountered.  Please review your entered information.
      </div>
    </div>
  </form>
</div>
